// extracted by mini-css-extract-plugin
module.exports = {"moreBtn":"AMA1s","readMore":"Hvysg"};